import React from 'react'
import { UserRoles } from '../../../constants/user-roles'
import AppointmentListCard from '../../../containers/AppointmentListWrapper'
import MainProfile from '../MainProfile/MainProfile'
import PatientProfileDetails from './PatientProfileDetails'
import Documents from '../../../containers/Documents'
import AppointmentListing from './AppointmentsList/AppointmentListing'
import ClinicalNotesListWrapper from '../../../containers/ClinicalNotes/ClinicalNotesListWrapper'
import { getLoggedInUserRole } from '../../../utilities'

const PatientProfile = (props) => {
    const userRole = getLoggedInUserRole()
    const tabsArr = [
        {
            label: 'profile',
            components: (
                <PatientProfileDetails {...props} />
            ),
        },
        // {
        //     label: 'appointments',
        //     components: (
        //         <AppointmentListCard
        //             userId={props.userId}
        //             role={UserRoles.PATIENT}
        //         />
        //     ),
        // },
        // { label: 'Health summary', components: null },
        // {
        //     label: 'clinical notes',
        //     components: (
        //         <ClinicalNotesListWrapper
        //             userId={props.userId}
        //             checkprovider={
        //                 userRole === UserRoles.PROVIDER
        //             }
        //         />
        //     ),
        // },
        // {
        //     label: 'Documents',
        //     components: (
        //         <Documents
        //             userid={props.userId}
        //             checkprovider={
        //                 userRole === UserRoles.PROVIDER
        //             }
        //         />
        //     ),
        // },
        // { label: 'labs', components: null },
        // { label: 'imaging', components: null },
        // { label: 'eRx', components: null },
    ]
    const { isCreateMode } = props

    return (
        <MainProfile
            tabsList={tabsArr}
            isCreateMode={isCreateMode}
        />
    )
}
export default PatientProfile
